var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46018 0.77621C1.75711 0.77621 2.05404 0.889104 2.2806 1.11567L10.7856 9.62071C11.2388 10.0731 11.2388 10.8077 10.7856 11.2608L2.2806 19.7666C1.82747 20.2197 1.09365 20.2197 0.640525 19.7666C0.187397 19.3142 0.187397 18.5797 0.640525 18.1265L8.32514 10.4411L0.640526 2.75652C0.187399 2.30339 0.187399 1.56957 0.640527 1.11644C0.866318 0.889106 1.16325 0.77621 1.46018 0.77621Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.c4bc11aca144440350a4fcdfe5a69f12.svg";
export { ForwardRef as ReactComponent };